/* Botão de excluir item no drawer do carrinho.

   O theme.js reescreve as linhas do carrinho por innerHTML e não inclui
   remoção — só dá para zerar no "−", item a item. Em vez de mexer no
   theme.js (que é um bundle compilado), injetamos o botão em cada linha e
   reinjetamos sempre que o tema re-renderiza a lista. */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-cart-items]');
  if (!itemsEl) return;

  var ICONE =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>';

  function injetar() {
    Array.prototype.forEach.call(itemsEl.querySelectorAll('[data-line-key]'), function (linha) {
      if (linha.querySelector('[data-line-remove]')) return;

      var titulo = linha.querySelector('p');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lof-line-remove';
      btn.setAttribute('data-line-remove', linha.getAttribute('data-line-key'));
      btn.setAttribute('aria-label', 'Remover ' + (titulo ? titulo.textContent.trim() : 'item') + ' do carrinho');
      btn.title = 'Remover';
      btn.innerHTML = ICONE;
      linha.appendChild(btn);
    });
  }

  /* childList sem subtree: as inserções que fazemos dentro das linhas não
     disparam o observer, então não há laço. */
  if (window.MutationObserver) {
    new MutationObserver(injetar).observe(itemsEl, { childList: true });
  }
  injetar();

  drawer.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-line-remove'), quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('remove_failed');
        /* Reaproveita o fluxo do theme.js: re-renderiza a lista e mantém o
           drawer aberto. */
        var toggle = document.querySelector('[data-cart-toggle]');
        if (toggle) toggle.click();
      })
      .catch(function () {
        btn.disabled = false;
      });
  });
})();
